import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import itTranslation from "./locales/it/translation.json";
import ptBrTranslation from "./locales/pt-BR/translation.json";
import germanTranslation from "./locales/de-DE/translation.json";
import frenchTranslation from "./locales/fr/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    fallbackLng: "en",
    supportedLngs: ["en", "es", "it", "pt", "pt-BR", "de", "de-DE", "fr"],
    // load: "currentOnly",
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
      it: { translation: itTranslation },
      "pt-BR": { translation: ptBrTranslation },
      pt: { translation: ptBrTranslation },
      "de-DE": { translation: germanTranslation },
      de: { translation: germanTranslation },
      fr: { translation: frenchTranslation },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
